import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";

const EmployeeEditModal = ({
  show,
  onHide,
  handleSubmit,
  onUpdate,
  register,
  errors,
  control,
  title,
  size = "md",
  type,
  editFields = [],
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "familyDetails",
  });
  const {
    fields: eduFields,
    append: appendEdu,
    remove: removeEdu,
  } = useFieldArray({
    control,
    name: "educationDetails",
  });
  const standardRelationships = [
    "Spouse",
    "Father",
    "Mother",
    "Son",
    "Daughter",
    "Father in law",
    "Mother in law",
  ];
  console.log("type", type)
  return (
    <Modal show={show} onHide={onHide} centered size={size}>
      <Modal.Header className="bg-light">
        <Modal.Title className="h5">{title}</Modal.Title>
        <button
          type="button"
          onClick={onHide}
          className="btn p-0 border-0 shadow-none position-absolute"
          style={{
            top: "15px",
            right: "15px",
            zIndex: 1,
          }}
          aria-label="Close"
        >
          <i className="bi bi-x-lg fs-5 text-dark"></i>
        </button>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit(onUpdate)}>
          {type === "family" ? (
            <>
              {fields.map((item, index) => (
                <Row
                  key={item.id}
                  className="align-items-start gx-3 border-bottom pb-4 mb-4"
                >
                  <Col md={4} className="mb-3">
                    <Form.Label className="small fw-bold text-muted">
                      Name
                    </Form.Label>
                    <Form.Control
                      {...register(`familyDetails.${index}.name`, {
                        required: "Name is required",
                        pattern: {
                          value: /^[a-zA-Z\s]*$/,
                          message:
                            "Numbers and special characters are not allowed",
                        },
                      })}
                      placeholder="Enter name"
                      isInvalid={!!errors?.familyDetails?.[index]?.name}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          "",
                        );
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.familyDetails?.[index]?.name?.message}
                    </Form.Control.Feedback>
                  </Col>

                  <Col md={4} className="mb-3">
                    <Form.Label className="small fw-bold text-muted">
                      Relationship
                    </Form.Label>
                    <Form.Select
                      {...register(`familyDetails.${index}.relationship`, {
                        required: "Please select relationship",
                      })}
                      isInvalid={!!errors?.familyDetails?.[index]?.relationship}
                    >
                      <option value="">Select relationship</option>
                      {item.relationship &&
                        !standardRelationships.includes(item.relationship) && (
                          <option value={item.relationship}>
                            {item.relationship}
                          </option>
                        )}
                      <option value="Spouse">Spouse</option>
                      <option value="Father">Father</option>
                      <option value="Mother">Mother</option>
                      <option value="Son">Son</option>
                      <option value="Daughter">Daughter</option>
                      <option value="Father in law">Father in law</option>
                      <option value="Mother in law">Mother in law</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors?.familyDetails?.[index]?.relationship?.message}
                    </Form.Control.Feedback>
                  </Col>

                  <Col md={4} className="mb-3">
                    <Form.Label className="small fw-bold text-muted">
                      DOB
                    </Form.Label>
                    <Form.Control
                      type="date"
                      {...register(`familyDetails.${index}.dob`, {
                        required: "DOB is required",
                      })}
                      isInvalid={!!errors?.familyDetails?.[index]?.dob}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.familyDetails?.[index]?.dob?.message}
                    </Form.Control.Feedback>
                  </Col>
                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      Phone No.
                    </Form.Label>
                    <Form.Control
                      {...register(`familyDetails.${index}.phone`, {
                        required: "Phone no. is required",
                        minLength: {
                          value: 10,
                          message: "Must be exactly 10 digits",
                        },
                        pattern: {
                          value: /^[6-9]\d{9}$/,
                          message: "Must start with 6,7,8,or 9",
                        },
                      })}
                      placeholder="Phone no."
                      maxLength={10}
                      isInvalid={!!errors?.familyDetails?.[index]?.phone}
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.familyDetails?.[index]?.phone?.message}
                    </Form.Control.Feedback>
                  </Col>

                  <Col md={2} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      Gender
                    </Form.Label>
                    <Form.Select
                      {...register(`familyDetails.${index}.gender`, {
                        required: "Gender is required",
                      })}
                      isInvalid={!!errors?.familyDetails?.[index]?.gender}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors?.familyDetails?.[index]?.gender?.message}
                    </Form.Control.Feedback>
                  </Col>

                  <Col md={2} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      Age
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter age"
                      maxLength={3}
                      {...register(`familyDetails.${index}.age`, {
                        required: "Age is required",
                        maxLength: {
                          value: 3,
                          message: "Cannot exceed 3 digits",
                        },
                      })}
                      isInvalid={!!errors?.familyDetails?.[index]?.age}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.familyDetails?.[index]?.age?.message}
                    </Form.Control.Feedback>
                  </Col>

                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      SI Amount
                    </Form.Label>
                    <Form.Select
                      {...register(`familyDetails.${index}.amount`, {
                        required: "SI Amount is required",
                      })}
                      isInvalid={!!errors?.familyDetails?.[index]?.amount}
                    >
                      <option value="">Select Amount</option>
                      <option value="500000">500,000</option>
                      <option value="1000000">1,000,000</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors?.familyDetails?.[index]?.amount?.message}
                    </Form.Control.Feedback>
                  </Col>
                  <Col md={12} className="pt-4 text-center">
                    {fields.length > 0 && (
                      <i
                        className="bi bi-trash3 text-danger cursor-pointer fs-5"
                        onClick={() => remove(index)}
                        title="Remove Member"
                      ></i>
                    )}
                  </Col>
                </Row>
              ))}

              <div className="d-flex flex-column align-items-center mt-3">
                <Button
                  variant="outline-primary"
                  className="rounded-circle d-flex align-items-center justify-content-center border-2"
                  style={{ width: "40px", height: "40px" }}
                  onClick={() =>
                    append({
                      name: "",
                      relationship: "",
                      dob: "",
                      phone: "",
                      gender: "",
                      age: "",
                      amount: "",
                    })
                  }
                >
                  <i className="bi bi-plus-lg fw-bold"></i>
                </Button>
                <span className="small text-primary fw-bold mt-2">
                  Add Member
                </span>
              </div>
            </>
          ) : type === "experience" ? (
            <>
              {fields.map((item, index) => (
                <Row
                  key={item.id}
                  className="align-items-start mb-4 gx-3 border-bottom pb-4"
                >
                  {/* Row 1: Primary Work Info */}
                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      Employer Name
                    </Form.Label>
                    <Form.Control
                      className="form-control-sm border-secondary-subtle"
                      {...register(
                        `employmentHistory.${index}.previousEmployerName`,
                        { required: "Required" },
                      )}
                      placeholder="e.g. Google or Moptra Infotech"
                      isInvalid={
                        !!errors?.employmentHistory?.[index]
                          ?.previousEmployerName
                      }
                    />
                  </Col>
                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      Department
                    </Form.Label>
                    <Form.Control
                      className="form-control-sm border-secondary-subtle"
                      {...register(`employmentHistory.${index}.department`)}
                      placeholder="e.g. IT or Sales"
                    />
                  </Col>
                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      Designation
                    </Form.Label>
                    <Form.Control
                      className="form-control-sm border-secondary-subtle"
                      {...register(`employmentHistory.${index}.designation`, {
                        required: "Required",
                      })}
                      placeholder="e.g. Front End Developer"
                      isInvalid={
                        !!errors?.employmentHistory?.[index]?.designation
                      }
                    />
                  </Col>
                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      Employee Code
                    </Form.Label>
                    <Form.Control
                      className="form-control-sm border-secondary-subtle"
                      {...register(`employmentHistory.${index}.employeeCode`)}
                      placeholder="e.g. EMP123"
                    />
                  </Col>
                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      From Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      className="form-control-sm border-secondary-subtle"
                      {...register(
                        `employmentHistory.${index}.employmentPeriodFrom`,
                        { required: "Required" },
                      )}
                      isInvalid={
                        !!errors?.employmentHistory?.[index]
                          ?.employmentPeriodFrom
                      }
                    />
                  </Col>
                  <Col md={4} className="mb-2">
                    <Form.Label className="small fw-bold text-muted">
                      To Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      className="form-control-sm border-secondary-subtle"
                      {...register(
                        `employmentHistory.${index}.employmentPeriodTo`,
                        { required: "Required" },
                      )}
                      isInvalid={
                        !!errors?.employmentHistory?.[index]?.employmentPeriodTo
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <Form.Label className="small fw-bold text-muted">
                      Reporting Manager
                    </Form.Label>
                    <Form.Control
                      className="form-control-sm border-secondary-subtle"
                      {...register(`employmentHistory.${index}.managerName`)}
                      placeholder="Enter full name"
                    />
                  </Col>
                  <Col md={4}>
                    <Form.Label className="small fw-bold text-muted">
                      Manager Phone
                    </Form.Label>
                    <Form.Control
                      className="form-control-sm border-secondary-subtle"
                      {...register(`employmentHistory.${index}.mobileNumber`)}
                      placeholder="e.g. 9876543210"
                      onInput={(e) =>
                      (e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10))
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <Form.Label className="small fw-bold text-muted">
                      Manager Email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      className="form-control-sm border-secondary-subtle"
                      {...register(`employmentHistory.${index}.managerEmail`)}
                      placeholder="name@company.com"
                    />
                  </Col>
                  <Col md={12} className="pt-3 text-center">
                    {fields.length > 1 && (
                      <span
                        className="text-danger cursor-pointer small fw-bold"
                        onClick={() => remove(index)}
                      >
                        <i className="bi bi-trash3 me-1"></i>
                      </span>
                    )}
                  </Col>
                </Row>
              ))}

              <div className="d-flex flex-column align-items-center">
                <Button
                  variant="outline-primary"
                  className="rounded-circle d-flex align-items-center justify-content-center border-2"
                  style={{ width: "40px", height: "40px" }}
                  onClick={() =>
                    append({
                      previousEmployerName: "",
                      department: "",
                      designation: "",
                      employeeCode: "",
                      employmentPeriodFrom: "",
                      employmentPeriodTo: "",
                      managerName: "",
                      mobileNumber: "",
                      managerEmail: "",
                    })
                  }
                >
                  <i className="bi bi-plus-lg fw-bold"></i>
                </Button>
                <span className="small text-primary fw-bold mt-2">
                  Add Another Experience
                </span>
              </div>
            </>
          ) : type === "education" ? (
            <>
              {eduFields.map((item, index) => {
                const getRule = (name) =>
                  editFields.find((f) => f.name === name)?.rules || {};

                return (
                  <Row
                    key={item.id}
                    className="align-items-start mb-4 gx-3 border-bottom pb-4"
                  >
                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        Qualification
                      </Form.Label>
                      <Form.Control
                        className="form-control-sm border-secondary-subtle"
                        placeholder="Enter Degree Name"
                        {...register(
                          `educationDetails.${index}.degreeName`,
                          getRule("degreeName"),
                        )}
                        isInvalid={
                          !!errors?.educationDetails?.[index]?.degreeName
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.educationDetails?.[index]?.degreeName?.message}
                      </Form.Control.Feedback>
                    </Col>
                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        Field of Study
                      </Form.Label>
                      <Form.Control
                        className="form-control-sm border-secondary-subtle"
                        placeholder="Enter Field of Study"
                        {...register(
                          `educationDetails.${index}.fieldOfStudy`,
                          getRule("fieldOfStudy"),
                        )}
                        isInvalid={
                          !!errors?.educationDetails?.[index]?.fieldOfStudy
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {
                          errors?.educationDetails?.[index]?.fieldOfStudy
                            ?.message
                        }
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        Institution
                      </Form.Label>
                      <Form.Control
                        className="form-control-sm border-secondary-subtle"
                        placeholder="Enter Institution"
                        {...register(
                          `educationDetails.${index}.institutionName`,
                          getRule("institutionName"),
                        )}
                        isInvalid={
                          !!errors?.educationDetails?.[index]?.institutionName
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {
                          errors?.educationDetails?.[index]?.institutionName
                            ?.message
                        }
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        Location
                      </Form.Label>
                      <Form.Control
                        className="form-control-sm border-secondary-subtle"
                        placeholder="Enter Location"
                        {...register(
                          `educationDetails.${index}.location`,
                          getRule("location"),
                        )}
                        isInvalid={
                          !!errors?.educationDetails?.[index]?.location
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.educationDetails?.[index]?.location?.message}
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        Grade/CGPA
                      </Form.Label>
                      <Form.Control
                        className="form-control-sm border-secondary-subtle"
                        placeholder="Enter Grade/CGPA"
                        {...register(
                          `educationDetails.${index}.gradeOrcgpa`,
                          getRule("gradeOrcgpa"),
                        )}
                        isInvalid={
                          !!errors?.educationDetails?.[index]?.gradeOrcgpa
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {
                          errors?.educationDetails?.[index]?.gradeOrcgpa
                            ?.message
                        }
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        From Date
                      </Form.Label>
                      <Form.Control
                        type="date"
                        className="form-control-sm border-secondary-subtle"
                        {...register(
                          `educationDetails.${index}.fromDate`,
                          getRule("fromDate"),
                        )}
                        isInvalid={
                          !!errors?.educationDetails?.[index]?.fromDate
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.educationDetails?.[index]?.fromDate?.message}
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        To Date
                      </Form.Label>
                      <Form.Control
                        type="date"
                        className="form-control-sm border-secondary-subtle"
                        {...register(
                          `educationDetails.${index}.toDate`,
                          getRule("toDate"),
                        )}
                        isInvalid={!!errors?.educationDetails?.[index]?.toDate}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.educationDetails?.[index]?.toDate?.message}
                      </Form.Control.Feedback>
                    </Col>


                    <Col md={3} className="mb-2">
                      <Form.Label className="small fw-bold text-muted">
                        Roll No
                      </Form.Label>
                      <Form.Control
                        className="form-control-sm border-secondary-subtle"
                        placeholder="Enter Roll No"
                        {...register(
                          `educationDetails.${index}.rollNumber`,
                          getRule("rollNumber"),
                        )}
                        isInvalid={
                          !!errors?.educationDetails?.[index]?.rollNumber
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.educationDetails?.[index]?.rollNumber?.message}
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={12} className="pt-3 text-center">
                      {eduFields.length > 1 && (
                        <span
                          className="text-danger cursor-pointer small fw-bold"
                          onClick={() => removeEdu(index)}
                        >
                          <i className="bi bi-trash3 me-1"></i>
                        </span>
                      )}
                    </Col>
                  </Row>
                );
              })}
              <div className="d-flex flex-column align-items-center">
                <Button
                  variant="outline-primary"
                  className="rounded-circle d-flex align-items-center justify-content-center border-2"
                  style={{ width: "40px", height: "40px" }}
                  onClick={() =>
                    appendEdu({
                      degreeName: "",
                      fieldOfStudy: "",
                      institutionName: "",
                      location: "",
                      gradeOrcgpa: "",
                      fromDate: "",
                      toDate: "",
                      rollNumber: "",
                    })
                  }
                >
                  <i className="bi bi-plus-lg fw-bold"></i>
                </Button>
                <span className="small text-primary fw-bold mt-2">
                  Add Another Education
                </span>
              </div>
            </>
          ) : type === "professional " ? (

            <Row className="gx-3"> {/* gx-3 fields ke beech ka gap control karta hai */}
              <Col md={6} className="mb-3">
                <Form.Label className="small fw-bold text-muted">Reference Name</Form.Label>
                <Form.Control
                  className="form-control-sm border-purple-custom"
                  placeholder="Enter Name"
                  {...register(`references.${index}.name`, getRule("Reference Name"))}
                  isInvalid={!!errors?.references?.[index]?.name}
                />
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label className="small fw-bold text-muted">Email</Form.Label>
                <Form.Control
                  className="form-control-sm border-purple-custom"
                  placeholder="Enter Email"
                  {...register(`references.${index}.email`, getRule("Email"))}
                  isInvalid={!!errors?.references?.[index]?.email}
                />
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label className="small fw-bold text-muted">Contact</Form.Label>
                <Form.Control
                  className="form-control-sm border-purple-custom"
                  placeholder="Enter Contact Number"
                  {...register(`references.${index}.contact`, getRule("Contact"))}
                  isInvalid={!!errors?.references?.[index]?.contact}
                />
              </Col>
              <Col md={6} className="mb-3">
                <Form.Label className="small fw-bold text-muted">Designation</Form.Label>
                <Form.Control
                  className="form-control-sm border-purple-custom"
                  placeholder="Enter Designation"
                  {...register(`references.${index}.designation`, getRule("Designation"))}
                  isInvalid={!!errors?.references?.[index]?.designation}
                />
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label className="small fw-bold text-muted">Relationship</Form.Label>
                <Form.Control
                  className="form-control-sm border-purple-custom"
                  placeholder="Enter Relationship"
                  {...register(`references.${index}.relationship`, getRule("Relationship"))}
                  isInvalid={!!errors?.references?.[index]?.relationship}
                />
              </Col>
              <Col md={6} className="mb-3">
                <Form.Label className="small fw-bold text-muted">Employee ID</Form.Label>
                <Form.Control
                  className="form-control-sm border-purple-custom"
                  placeholder="Enter Employee ID"
                  {...register(`references.${index}.employeeId`, getRule("Employee ID"))}
                  isInvalid={!!errors?.references?.[index]?.employeeId}
                />
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label className="small fw-bold text-muted">Department</Form.Label>
                <Form.Control
                  className="form-control-sm border-purple-custom"
                  placeholder="Enter Department"
                  {...register(`references.${index}.department`, getRule("Department"))}
                  isInvalid={!!errors?.references?.[index]?.department}
                />
              </Col>
            </Row>


          ) : type === "additional " ? (
            <>
              <Row className="gx-3"> {/* gx-3 fields ke beech ka gap control karta hai */}

                {/* Row 1 */}
                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Passport Number</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Passport Number"
                    {...register(`additionalInfo.${index}.passportNumber`, getRule("Passport Number"))}
                    isInvalid={!!errors?.additionalInfo?.[index]?.passportNumber}
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Hobbies</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="e.g. Cooking and exploring new recipes"
                    {...register(`additionalInfo.${index}.hobbies`, getRule("Hobbies"))}
                    isInvalid={!!errors?.additionalInfo?.[index]?.hobbies}
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Illness</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Illness Details"
                    {...register(`additionalInfo.${index}.illness`, getRule("Illness"))}
                    isInvalid={!!errors?.additionalInfo?.[index]?.illness}
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Reference Name</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Name"
                    {...register(`references.${index}.name`, getRule("Reference Name"))}
                    isInvalid={!!errors?.references?.[index]?.name}
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Email</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Email"
                    {...register(`references.${index}.email`, getRule("Email"))}
                    isInvalid={!!errors?.references?.[index]?.email}
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Contact</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Contact Number"
                    {...register(`references.${index}.contact`, getRule("Contact"))}
                    isInvalid={!!errors?.references?.[index]?.contact}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Designation</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Designation"
                    {...register(`references.${index}.designation`, getRule("Designation"))}
                    isInvalid={!!errors?.references?.[index]?.designation}
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Relationship</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Relationship"
                    {...register(`references.${index}.relationship`, getRule("Relationship"))}
                    isInvalid={!!errors?.references?.[index]?.relationship}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Employee ID</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Employee ID"
                    {...register(`references.${index}.employeeId`, getRule("Employee ID"))}
                    isInvalid={!!errors?.references?.[index]?.employeeId}
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Department</Form.Label>
                  <Form.Control
                    className="form-control-sm border-purple-custom"
                    placeholder="Enter Department"
                    {...register(`references.${index}.department`, getRule("Department"))}
                    isInvalid={!!errors?.references?.[index]?.department}
                  />
                </Col>
              </Row>
            </>
          )
            : type !== "education" && type !== "experience" && type !== "family" ? (
              <Row>
                {editFields.map((field) => (
                  <Col md={6} key={field.name} className="mb-3">
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted">{field.label}</Form.Label>
                      {field.type === "select" ? (
                        <Form.Select
                          className="form-control-sm border-secondary-subtle"
                          {...register(field.name, field.rules)}
                          isInvalid={!!errors[field.name]}
                        >
                          <option value="">Select {field.label}</option>
                          {field.options.map((opt) => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </Form.Select>
                      ) : (
                        <Form.Control
                          type={field.type}
                          className="form-control-sm border-secondary-subtle"
                          {...register(field.name, {
                            ...field.rules,
                            // Automatically strips hyphens (or any non-digits) behind the scenes for the form state
                            setValueAs: (value) => {
                              if (field.name === "adhaarNo" && typeof value === "string") {
                                return value.replace(/\D/g, ""); // \D removes hyphens, spaces, etc.
                              }
                              return value;
                            }
                          })}
                          isInvalid={!!errors[field.name]}
                          onInput={(e) => {
                            // Formatting PAN to uppercase automatically
                            if (field.name === "panNo") {
                              e.target.value = e.target.value.toUpperCase();
                            }
                            // THIS LINE removes hyphens instantly if a user pastes "1234-1234-1234"
                            if (["adhaarNo", "uanNo", "secondaryMobile", "noOfChildren"].includes(field.name)) {
                              e.target.value = e.target.value.replace(/\D/g, "");
                              if (field.name === "adhaarNo" || field.name === "uanNo") e.target.value = e.target.value.slice(0, 12);
                              if (field.name === "secondaryMobile") e.target.value = e.target.value.slice(0, 10);
                            }
                            // Restricting text-only fields
                            if (["fatherName", "motherName"].includes(field.name)) {
                              e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                            }
                          }}
                        />
                      )}
                      <Form.Control.Feedback type="invalid">
                        {errors[field.name]?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            ) : (
              <>
                {console.log("field.name", type)}
                {editFields.map((field) => (
                  <Form.Group key={field.label} className="mb-0">
                    <Form.Label className="fw-bold small">
                      {field.label}
                    </Form.Label>
                    <Form.Control
                      className="mb-2"
                      type={field.type}
                      max={field.max}
                      placeholder={field.placeholder || `Enter ${field.label}`}
                      {...register(field.name, field.rules)}
                      onInput={(e) => {

                        if (
                          field.name === "mobileNo" ||
                          field.name === "aadhaarNo" || field.name === "adhaarNo"
                        ) {
                          e.target.value = e.target.value.replace(/\D/g, "");
                          if (field.name === "mobileNo")
                            e.target.value = e.target.value.slice(0, 10);
                          if (field.name === "aadhaarNo" || field.name === "adhaarNo")
                            e.target.value = e.target.value.slice(0, 12);
                        }
                      }}
                    />
                    {errors[field.name] && (
                      <p className="error-msg text-danger small">
                        {errors[field.name]?.message}
                      </p>
                    )}
                  </Form.Group>
                ))}
              </>

            )}



        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="cancel-cta" onClick={onHide}>
          Close
        </Button>
        <Button variant="update-cta" onClick={handleSubmit(onUpdate)}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmployeeEditModal;
